import { computed, ComputedRef, watch } from 'vue';

import { useRoute } from '@/composables/router/VueRouter';
import { AppName } from '@/data/Branding';
import { useKnowledgeBaseStore } from '@/stores/KnowledgeBase';
import { useTracksStore } from '@/stores/Tracks';
import { useUIStateStore } from '@/stores/UIState';

const tracksStore = useTracksStore();

const uiStateStore = useUIStateStore();
const knowledgeBaseStore = useKnowledgeBaseStore();

export function usePageTitle() {
  const route = useRoute();

  const kbNotificationCount: ComputedRef<number> = computed(() => {
    return knowledgeBaseStore.kbNotificationCount;
  });

  const pageTitle: ComputedRef<string> = computed(() => {
    let title: string | undefined;
    if (uiStateStore.pageTitle) {
      title = uiStateStore.pageTitle;
    } else if (tracksStore.activeTrack) {
      title = tracksStore.activeTrack.title;
    } else {
      title = route.meta?.title;
      if (!title && route.matched) {
        for (let i = route.matched.length - 1; i >= 0 && !title; --i) {
          if (route.matched[i].meta.title) {
            title = route.matched[i].meta.title;
          }
        }
      }
    }
    return title || AppName;
  });

  const notificationCount: ComputedRef<number> = computed(() => {
    return (tracksStore.trackNotifications ? tracksStore.trackNotifications.length : 0) + kbNotificationCount.value;
  });

  function updatePageTitle(): void {
    let toSet: string = pageTitle.value;
    if (notificationCount.value) {
      toSet = `(${notificationCount.value}) ${toSet}`;
    }
    document.title = toSet;
  }

  watch(() => pageTitle.value, () => {
    updatePageTitle();
  }, { immediate: true });

  watch(() => notificationCount.value, () => {
    updatePageTitle();
  }, { immediate: true });
}
